let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bS1ax")).then(() => parcelRequire('5Dig0'));